"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ODataService = void 0;
var jinqu_1 = require("jinqu");
var jinqu_fetch_1 = require("jinqu-fetch");
var decorators_1 = require("./decorators");
var odata_query_provider_1 = require("./odata-query-provider");
var ODataService = /** @class */ (function () {
    function ODataService(baseAddress, ajaxProvider) {
        if (baseAddress === void 0) { baseAddress = ""; }
        if (ajaxProvider === void 0) { ajaxProvider = new jinqu_fetch_1.FetchProvider(); }
        this.baseAddress = baseAddress;
        this.ajaxProvider = ajaxProvider;
    }
    ODataService.prototype.request = function (params, options) {
        var d = Object.assign({}, ODataService.defaultOptions);
        var o = (options || []).reduce(jinqu_1.mergeAjaxOptions, d);
        if (this.baseAddress) {
            if (this.baseAddress[this.baseAddress.length - 1] !== "/" && o.url && o.url[0] !== "/") {
                o.url = "/" + o.url;
            }
            o.url = this.baseAddress + (o.url || "");
        }
        var includeResponse = false;
        var countPrm = null;
        o.params = o.params || [];
        params = params || [];
        var inlineCountEnabled = false;
        params.forEach(function (p) {
            if (p.key === jinqu_1.QueryFunc.inlineCount) {
                o.params.push({ key: "$count", value: "true" });
                inlineCountEnabled = true;
            }
            else if (p.key === "$count") {
                countPrm = p;
            }
            else if (p.key === jinqu_1.AjaxFuncs.includeResponse) {
                includeResponse = true;
            }
            else {
                o.params.push(p);
            }
        });
        if (o.params.length) {
            o.url += "?" + o.params.map(function (p) { return p.key + "=" + encodeURIComponent(p.value); }).join("&");
        }
        o.params = [];
        if (countPrm) {
            o.url += "/$count";
            if (countPrm.value) {
                o.url += "/?$filter=" + encodeURIComponent(countPrm.value);
            }
        }
        return this.ajaxProvider.ajax(o)
            .then(function (r) {
            var value = r.value;
            if (value && value.value !== void 0) {
                value = value.value;
            }
            if (!inlineCountEnabled && !includeResponse) {
                return value;
            }
            return {
                inlineCount: inlineCountEnabled ? Number(r.value && r.value["odata.count"]) : void 0,
                response: includeResponse ? r.response : void 0,
                value: value,
            };
        });
    };
    ODataService.prototype.createQuery = function (resource, ctor) {
        if (typeof resource === "function") {
            ctor = resource;
            resource = decorators_1.getResource(ctor);
            if (!resource) {
                var r = /class (.*?)\s|\{|function (.*?)[\s|\(]/.exec(ctor.toString());
                resource = r[1] || r[2];
            }
        }
        var query = new odata_query_provider_1.ODataQueryProvider(this)
            .createQuery()
            .withOptions({ url: resource });
        return ctor ? query.cast(ctor) : query;
    };
    ODataService.defaultOptions = {};
    return ODataService;
}());
exports.ODataService = ODataService;
//# sourceMappingURL=odata-service.js.map